export default __webpack_public_path__ + "static/media/uploadfile.9a312167.svg";